/**
 * Generated by orval v8.18.0 🍺
 * Do not edit manually.
 * LiftAI API
 * LiftAI elevator/lift asset-management REST API.
 * OpenAPI spec version: 1.0.0 (v1)
 */
import type {
  AggregateResult,
  KnowledgeEntry,
  KnowledgeEntryCreateRequest,
  KnowledgeEntryCreated,
  PaginatedPropertyContractList,
  PatchedKnowledgeEntryUpdateRequest,
  PatchedPropertyContractRequest,
  PatchedPropertyRequest,
  PropertiesAggregateRetrieveParams,
  PropertiesContractsListParams,
  PropertiesFormListParams,
  PropertiesKnowledgeListParams,
  PropertiesListParams,
  Property,
  PropertyContract,
  PropertyContractRequest,
  PropertyForm,
  PropertyRequest
} from '../../model';

import { customFetch } from '../../../liftApiMutator';

export type propertiesListResponse200 = {
  data: Property[]
  status: 200
}

export type propertiesListResponseSuccess = (propertiesListResponse200) & {
  headers: Headers;
};
;

export type propertiesListResponse = (propertiesListResponseSuccess)

export const getPropertiesListUrl = (params?: PropertiesListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["portfolio","region"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : String(v));
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/properties/?${stringifiedParams}` : `/api/v1/properties/`
}

/**
 * Adds a GET-only ``aggregate`` action to a viewset.
 *
 * The viewset must declare ``AGGREGATE_CONFIG: AggregateConfig`` and a
 * ``filterset_class``. GET-only because the chat loopback only issues GET.
 */
export const propertiesList = async (params?: PropertiesListParams, options?: RequestInit): Promise<propertiesListResponse> => {

  return customFetch<propertiesListResponse>(getPropertiesListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}


export type propertiesCreateResponse201 = {
  data: Property
  status: 201
}

export type propertiesCreateResponseSuccess = (propertiesCreateResponse201) & {
  headers: Headers;
};
;

export type propertiesCreateResponse = (propertiesCreateResponseSuccess)

export const getPropertiesCreateUrl = () => {




  return `/api/v1/properties/`
}

/**
 * Adds a GET-only ``aggregate`` action to a viewset.
 *
 * The viewset must declare ``AGGREGATE_CONFIG: AggregateConfig`` and a
 * ``filterset_class``. GET-only because the chat loopback only issues GET.
 */
export const propertiesCreate = async (propertyRequest: PropertyRequest, options?: RequestInit): Promise<propertiesCreateResponse> => {

  return customFetch<propertiesCreateResponse>(getPropertiesCreateUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(propertyRequest)
  }
);}


export type propertiesRetrieveResponse200 = {
  data: Property
  status: 200
}

export type propertiesRetrieveResponseSuccess = (propertiesRetrieveResponse200) & {
  headers: Headers;
};
;

export type propertiesRetrieveResponse = (propertiesRetrieveResponseSuccess)

export const getPropertiesRetrieveUrl = (id: string,) => {




  return `/api/v1/properties/${id}/`
}

/**
 * Adds a GET-only ``aggregate`` action to a viewset.
 *
 * The viewset must declare ``AGGREGATE_CONFIG: AggregateConfig`` and a
 * ``filterset_class``. GET-only because the chat loopback only issues GET.
 */
export const propertiesRetrieve = async (id: string, options?: RequestInit): Promise<propertiesRetrieveResponse> => {

  return customFetch<propertiesRetrieveResponse>(getPropertiesRetrieveUrl(id),
  {
    ...options,
    method: 'GET'


  }
);}


export type propertiesUpdateResponse200 = {
  data: Property
  status: 200
}

export type propertiesUpdateResponseSuccess = (propertiesUpdateResponse200) & {
  headers: Headers;
};
;

export type propertiesUpdateResponse = (propertiesUpdateResponseSuccess)

export const getPropertiesUpdateUrl = (id: string,) => {




  return `/api/v1/properties/${id}/`
}

/**
 * Adds a GET-only ``aggregate`` action to a viewset.
 *
 * The viewset must declare ``AGGREGATE_CONFIG: AggregateConfig`` and a
 * ``filterset_class``. GET-only because the chat loopback only issues GET.
 */
export const propertiesUpdate = async (id: string,
    propertyRequest: PropertyRequest, options?: RequestInit): Promise<propertiesUpdateResponse> => {

  return customFetch<propertiesUpdateResponse>(getPropertiesUpdateUrl(id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(propertyRequest)
  }
);}


export type propertiesPartialUpdateResponse200 = {
  data: Property
  status: 200
}

export type propertiesPartialUpdateResponseSuccess = (propertiesPartialUpdateResponse200) & {
  headers: Headers;
};
;

export type propertiesPartialUpdateResponse = (propertiesPartialUpdateResponseSuccess)

export const getPropertiesPartialUpdateUrl = (id: string,) => {




  return `/api/v1/properties/${id}/`
}

/**
 * Adds a GET-only ``aggregate`` action to a viewset.
 *
 * The viewset must declare ``AGGREGATE_CONFIG: AggregateConfig`` and a
 * ``filterset_class``. GET-only because the chat loopback only issues GET.
 */
export const propertiesPartialUpdate = async (id: string,
    patchedPropertyRequest?: PatchedPropertyRequest, options?: RequestInit): Promise<propertiesPartialUpdateResponse> => {

  return customFetch<propertiesPartialUpdateResponse>(getPropertiesPartialUpdateUrl(id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(patchedPropertyRequest)
  }
);}


export type propertiesDestroyResponse204 = {
  data: void
  status: 204
}

export type propertiesDestroyResponseSuccess = (propertiesDestroyResponse204) & {
  headers: Headers;
};
;

export type propertiesDestroyResponse = (propertiesDestroyResponseSuccess)

export const getPropertiesDestroyUrl = (id: string,) => {




  return `/api/v1/properties/${id}/`
}

/**
 * Adds a GET-only ``aggregate`` action to a viewset.
 *
 * The viewset must declare ``AGGREGATE_CONFIG: AggregateConfig`` and a
 * ``filterset_class``. GET-only because the chat loopback only issues GET.
 */
export const propertiesDestroy = async (id: string, options?: RequestInit): Promise<propertiesDestroyResponse> => {

  return customFetch<propertiesDestroyResponse>(getPropertiesDestroyUrl(id),
  {
    ...options,
    method: 'DELETE'


  }
);}


export type propertiesContractsListResponse200 = {
  data: PaginatedPropertyContractList
  status: 200
}

export type propertiesContractsListResponseSuccess = (propertiesContractsListResponse200) & {
  headers: Headers;
};
;

export type propertiesContractsListResponse = (propertiesContractsListResponseSuccess)

export const getPropertiesContractsListUrl = (propertyPk: string,
    params?: PropertiesContractsListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/properties/${propertyPk}/contracts/?${stringifiedParams}` : `/api/v1/properties/${propertyPk}/contracts/`
}

/**
 * Basic API CRUD access to Property Contract entities.
 */
export const propertiesContractsList = async (propertyPk: string,
    params?: PropertiesContractsListParams, options?: RequestInit): Promise<propertiesContractsListResponse> => {

  return customFetch<propertiesContractsListResponse>(getPropertiesContractsListUrl(propertyPk,params),
  {
    ...options,
    method: 'GET'


  }
);}


export type propertiesContractsCreateResponse201 = {
  data: PropertyContract
  status: 201
}

export type propertiesContractsCreateResponseSuccess = (propertiesContractsCreateResponse201) & {
  headers: Headers;
};
;

export type propertiesContractsCreateResponse = (propertiesContractsCreateResponseSuccess)

export const getPropertiesContractsCreateUrl = (propertyPk: string,) => {




  return `/api/v1/properties/${propertyPk}/contracts/`
}

/**
 * Basic API CRUD access to Property Contract entities.
 */
export const propertiesContractsCreate = async (propertyPk: string,
    propertyContractRequest: PropertyContractRequest, options?: RequestInit): Promise<propertiesContractsCreateResponse> => {

  return customFetch<propertiesContractsCreateResponse>(getPropertiesContractsCreateUrl(propertyPk),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(propertyContractRequest)
  }
);}


export type propertiesContractsRetrieveResponse200 = {
  data: PropertyContract
  status: 200
}

export type propertiesContractsRetrieveResponseSuccess = (propertiesContractsRetrieveResponse200) & {
  headers: Headers;
};
;

export type propertiesContractsRetrieveResponse = (propertiesContractsRetrieveResponseSuccess)

export const getPropertiesContractsRetrieveUrl = (propertyPk: string,
    id: string,) => {




  return `/api/v1/properties/${propertyPk}/contracts/${id}/`
}

/**
 * Basic API CRUD access to Property Contract entities.
 */
export const propertiesContractsRetrieve = async (propertyPk: string,
    id: string, options?: RequestInit): Promise<propertiesContractsRetrieveResponse> => {

  return customFetch<propertiesContractsRetrieveResponse>(getPropertiesContractsRetrieveUrl(propertyPk,id),
  {
    ...options,
    method: 'GET'


  }
);}


export type propertiesContractsUpdateResponse200 = {
  data: PropertyContract
  status: 200
}

export type propertiesContractsUpdateResponseSuccess = (propertiesContractsUpdateResponse200) & {
  headers: Headers;
};
;

export type propertiesContractsUpdateResponse = (propertiesContractsUpdateResponseSuccess)

export const getPropertiesContractsUpdateUrl = (propertyPk: string,
    id: string,) => {




  return `/api/v1/properties/${propertyPk}/contracts/${id}/`
}

/**
 * Basic API CRUD access to Property Contract entities.
 */
export const propertiesContractsUpdate = async (propertyPk: string,
    id: string,
    propertyContractRequest: PropertyContractRequest, options?: RequestInit): Promise<propertiesContractsUpdateResponse> => {

  return customFetch<propertiesContractsUpdateResponse>(getPropertiesContractsUpdateUrl(propertyPk,id),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(propertyContractRequest)
  }
);}


export type propertiesContractsPartialUpdateResponse200 = {
  data: PropertyContract
  status: 200
}

export type propertiesContractsPartialUpdateResponseSuccess = (propertiesContractsPartialUpdateResponse200) & {
  headers: Headers;
};
;

export type propertiesContractsPartialUpdateResponse = (propertiesContractsPartialUpdateResponseSuccess)

export const getPropertiesContractsPartialUpdateUrl = (propertyPk: string,
    id: string,) => {




  return `/api/v1/properties/${propertyPk}/contracts/${id}/`
}

/**
 * Basic API CRUD access to Property Contract entities.
 */
export const propertiesContractsPartialUpdate = async (propertyPk: string,
    id: string,
    patchedPropertyContractRequest?: PatchedPropertyContractRequest, options?: RequestInit): Promise<propertiesContractsPartialUpdateResponse> => {

  return customFetch<propertiesContractsPartialUpdateResponse>(getPropertiesContractsPartialUpdateUrl(propertyPk,id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(patchedPropertyContractRequest)
  }
);}


export type propertiesContractsDestroyResponse204 = {
  data: void
  status: 204
}

export type propertiesContractsDestroyResponseSuccess = (propertiesContractsDestroyResponse204) & {
  headers: Headers;
};
;

export type propertiesContractsDestroyResponse = (propertiesContractsDestroyResponseSuccess)

export const getPropertiesContractsDestroyUrl = (propertyPk: string,
    id: string,) => {




  return `/api/v1/properties/${propertyPk}/contracts/${id}/`
}

/**
 * Basic API CRUD access to Property Contract entities.
 */
export const propertiesContractsDestroy = async (propertyPk: string,
    id: string, options?: RequestInit): Promise<propertiesContractsDestroyResponse> => {

  return customFetch<propertiesContractsDestroyResponse>(getPropertiesContractsDestroyUrl(propertyPk,id),
  {
    ...options,
    method: 'DELETE'


  }
);}


export type propertiesKnowledgeListResponse200 = {
  data: KnowledgeEntry[]
  status: 200
}

export type propertiesKnowledgeListResponseSuccess = (propertiesKnowledgeListResponse200) & {
  headers: Headers;
};
;

export type propertiesKnowledgeListResponse = (propertiesKnowledgeListResponseSuccess)

export const getPropertiesKnowledgeListUrl = (propertyPk: string,
    params?: PropertiesKnowledgeListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/properties/${propertyPk}/knowledge/?${stringifiedParams}` : `/api/v1/properties/${propertyPk}/knowledge/`
}

/**
 * A property's knowledge: its own entries and every one of its cars'.
 */
export const propertiesKnowledgeList = async (propertyPk: string,
    params?: PropertiesKnowledgeListParams, options?: RequestInit): Promise<propertiesKnowledgeListResponse> => {

  return customFetch<propertiesKnowledgeListResponse>(getPropertiesKnowledgeListUrl(propertyPk,params),
  {
    ...options,
    method: 'GET'


  }
);}


export type propertiesKnowledgeCreateResponse201 = {
  data: KnowledgeEntryCreated
  status: 201
}

export type propertiesKnowledgeCreateResponseSuccess = (propertiesKnowledgeCreateResponse201) & {
  headers: Headers;
};
;

export type propertiesKnowledgeCreateResponse = (propertiesKnowledgeCreateResponseSuccess)

export const getPropertiesKnowledgeCreateUrl = (propertyPk: string,) => {




  return `/api/v1/properties/${propertyPk}/knowledge/`
}

/**
 * A property's knowledge: its own entries and every one of its cars'.
 */
export const propertiesKnowledgeCreate = async (propertyPk: string,
    knowledgeEntryCreateRequest: KnowledgeEntryCreateRequest, options?: RequestInit): Promise<propertiesKnowledgeCreateResponse> => {

  return customFetch<propertiesKnowledgeCreateResponse>(getPropertiesKnowledgeCreateUrl(propertyPk),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(knowledgeEntryCreateRequest)
  }
);}


export type propertiesKnowledgeRetrieveResponse200 = {
  data: KnowledgeEntry
  status: 200
}

export type propertiesKnowledgeRetrieveResponseSuccess = (propertiesKnowledgeRetrieveResponse200) & {
  headers: Headers;
};
;

export type propertiesKnowledgeRetrieveResponse = (propertiesKnowledgeRetrieveResponseSuccess)

export const getPropertiesKnowledgeRetrieveUrl = (propertyPk: string,
    id: string,) => {




  return `/api/v1/properties/${propertyPk}/knowledge/${id}/`
}

/**
 * A property's knowledge: its own entries and every one of its cars'.
 */
export const propertiesKnowledgeRetrieve = async (propertyPk: string,
    id: string, options?: RequestInit): Promise<propertiesKnowledgeRetrieveResponse> => {

  return customFetch<propertiesKnowledgeRetrieveResponse>(getPropertiesKnowledgeRetrieveUrl(propertyPk,id),
  {
    ...options,
    method: 'GET'


  }
);}


export type propertiesKnowledgePartialUpdateResponse200 = {
  data: KnowledgeEntry
  status: 200
}

export type propertiesKnowledgePartialUpdateResponseSuccess = (propertiesKnowledgePartialUpdateResponse200) & {
  headers: Headers;
};
;

export type propertiesKnowledgePartialUpdateResponse = (propertiesKnowledgePartialUpdateResponseSuccess)

export const getPropertiesKnowledgePartialUpdateUrl = (propertyPk: string,
    id: string,) => {




  return `/api/v1/properties/${propertyPk}/knowledge/${id}/`
}

/**
 * A property's knowledge: its own entries and every one of its cars'.
 */
export const propertiesKnowledgePartialUpdate = async (propertyPk: string,
    id: string,
    patchedKnowledgeEntryUpdateRequest?: PatchedKnowledgeEntryUpdateRequest, options?: RequestInit): Promise<propertiesKnowledgePartialUpdateResponse> => {

  return customFetch<propertiesKnowledgePartialUpdateResponse>(getPropertiesKnowledgePartialUpdateUrl(propertyPk,id),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(patchedKnowledgeEntryUpdateRequest)
  }
);}


export type propertiesKnowledgeDestroyResponse204 = {
  data: void
  status: 204
}

export type propertiesKnowledgeDestroyResponseSuccess = (propertiesKnowledgeDestroyResponse204) & {
  headers: Headers;
};
;

export type propertiesKnowledgeDestroyResponse = (propertiesKnowledgeDestroyResponseSuccess)

export const getPropertiesKnowledgeDestroyUrl = (propertyPk: string,
    id: string,) => {




  return `/api/v1/properties/${propertyPk}/knowledge/${id}/`
}

/**
 * A property's knowledge: its own entries and every one of its cars'.
 */
export const propertiesKnowledgeDestroy = async (propertyPk: string,
    id: string, options?: RequestInit): Promise<propertiesKnowledgeDestroyResponse> => {

  return customFetch<propertiesKnowledgeDestroyResponse>(getPropertiesKnowledgeDestroyUrl(propertyPk,id),
  {
    ...options,
    method: 'DELETE'


  }
);}


export type propertiesKnowledgeRestoreResponse200 = {
  data: KnowledgeEntry
  status: 200
}

export type propertiesKnowledgeRestoreResponseSuccess = (propertiesKnowledgeRestoreResponse200) & {
  headers: Headers;
};
;

export type propertiesKnowledgeRestoreResponse = (propertiesKnowledgeRestoreResponseSuccess)

export const getPropertiesKnowledgeRestoreUrl = (propertyPk: string,
    id: string,) => {




  return `/api/v1/properties/${propertyPk}/knowledge/${id}/restore/`
}

/**
 * Makes a replaced entry current again.
 */
export const propertiesKnowledgeRestore = async (propertyPk: string,
    id: string, options?: RequestInit): Promise<propertiesKnowledgeRestoreResponse> => {

  return customFetch<propertiesKnowledgeRestoreResponse>(getPropertiesKnowledgeRestoreUrl(propertyPk,id),
  {
    ...options,
    method: 'POST'


  }
);}


export type propertiesAggregateRetrieveResponse200 = {
  data: AggregateResult
  status: 200
}

export type propertiesAggregateRetrieveResponseSuccess = (propertiesAggregateRetrieveResponse200) & {
  headers: Headers;
};
;

export type propertiesAggregateRetrieveResponse = (propertiesAggregateRetrieveResponseSuccess)

export const getPropertiesAggregateRetrieveUrl = (params: PropertiesAggregateRetrieveParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/properties/aggregate/?${stringifiedParams}` : `/api/v1/properties/aggregate/`
}

/**
 * Adds a GET-only ``aggregate`` action to a viewset.
 *
 * The viewset must declare ``AGGREGATE_CONFIG: AggregateConfig`` and a
 * ``filterset_class``. GET-only because the chat loopback only issues GET.
 */
export const propertiesAggregateRetrieve = async (params: PropertiesAggregateRetrieveParams, options?: RequestInit): Promise<propertiesAggregateRetrieveResponse> => {

  return customFetch<propertiesAggregateRetrieveResponse>(getPropertiesAggregateRetrieveUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}


export type propertiesFormListResponse200 = {
  data: PropertyForm[]
  status: 200
}

export type propertiesFormListResponseSuccess = (propertiesFormListResponse200) & {
  headers: Headers;
};
;

export type propertiesFormListResponse = (propertiesFormListResponseSuccess)

export const getPropertiesFormListUrl = (params?: PropertiesFormListParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["portfolio","region"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : String(v));
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/v1/properties/form/?${stringifiedParams}` : `/api/v1/properties/form/`
}

/**
 * Trimmed {id, name} property list for form dropdowns.
 *
 * Separate endpoint (SDK: propertiesFormList) so the generated type is the
 * precise PropertyForm shape rather than the full PropertySerializer — the
 * old ``?variant=form`` query param can't be typed per-value in OpenAPI.
 */
export const propertiesFormList = async (params?: PropertiesFormListParams, options?: RequestInit): Promise<propertiesFormListResponse> => {

  return customFetch<propertiesFormListResponse>(getPropertiesFormListUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}


